

export default {

    //experiment
    GET_EXPERIMENT_INFO: '/api/v1/user-experiment',

    //invite
    GET_INVITE_INFO: '/api/v1/user-invite',
    POST_INVITE_USER_CODE_NAME: '/api/v1/user-invite-code',
    POST_INVITE_CODE: '/api/v1/user-invite',

    //agreement
    GET_AGREEMENT_USER: '/api/v1/user-agreement',
    POST_AGREEMENT_USER: '/api/v1/user-agreement',

    //verify
    POST_VERIFY_PHONE_PREPARE: '/api/v1/user/verification/phone/prepare',
    POST_VERIFY_PHONE_PREPARE_GUEST: '/api/v1/user/verification/phone/prepare/guest',
    POST_VERIFY_PHONE_RESULT: '/api/v1/user/verification/phone/result',
    POST_VERIFY_PHONE_RESULT_STATUS: '/api/v1/user/verification/phone/result/status',
    POST_VERIFY_PHONE_RESULT_GUEST: '/api/v1/user/verification/phone/result/guest',
}